import React, {useState} from 'react';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import "./index.css";

const SubscriptionPriceDropDownComponent = (props) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen(prevState => !prevState);
    const [dropdownItem, setDropdownItem] = useState(props.defaultSubscriptionPrice);
    let dropdownItemObject = props.subscriptionPackagePrices;

    return (
        <div className="label-form-field-container">
            <div className="label-form-field-container-label">Subscription Price</div>
            <Dropdown isOpen={dropdownOpen}
                      toggle={toggle}
                      className="broadcaster-profile-subscription-dropdown-container">

                <DropdownToggle caret>
                <span>
                    <span
                        className="broadcaster-profile-subscription-dropdown-selection">{dropdownItemObject[dropdownItem]}</span>
                </span>
                </DropdownToggle>
                <DropdownMenu>
                    {
                        Object.keys(dropdownItemObject).map((key, index) => {
                            return (
                                <DropdownItem key={`broadcaster-profile-subscription-dropdown-item-${index}`}
                                              onClick={() => {
                                                  setDropdownItem(key)
                                                  props.setSubscriptionPrice(key)
                                              }}>{dropdownItemObject[key]}
                                </DropdownItem>)
                        })
                    }
                </DropdownMenu>
            </Dropdown>
        </div>
    );
}

export default SubscriptionPriceDropDownComponent;

